import React from 'react';
import { Spinner } from 'react-bootstrap';
import './SectionLoadingOverlay.css';

const SectionLoadingOverlay = () => {
    return (
        <div className="sectionLoadingOverlay">
            <Spinner animation="border" variant="light" />
        </div>
    );
};

export default SectionLoadingOverlay; 